<div class="main-db gap-top">

<!-- Main content -->
<section class="content">
  <div class="error-page">
    <h2 class="headline text-danger float-none">Access Denied</h2>

    <div class="error-content text-center" style="margin: 0 auto;">
      <h3><i class="fas fa-exclamation-triangle text-danger"></i> We are Sorry.</h3>

      <p>
        You do not have permission to access this page.<br/>
        Please contact your system administrator to request access.
      </p>
    </div>
  </div>
  <!-- /.error-page -->

</section>
<!-- /.content -->
</div>